import { Injectable, Type } from '@angular/core';
import { DashboardComponentStore } from '../models/DashboardComponent';
import { StrategyService } from './strategy.service';
import { ExChartComponent } from '../components/ex-chart/ex-chart.component';
import { ExKPIComponent } from '../components/ex-kpi/ex-kpi.component';
import { ExDatatableComponent } from '../components/ex-datatable/ex-datatable.component';
import { HorizontalBusinessGroupComponent } from '../components/ex-horizontal-business-group/ex-horizontal-business-group.component';
import { ExProjectReviewComponent } from '../components/ex-project-review/ex-project-review.component';

@Injectable({
    providedIn: 'root'
})
export class ComponentService {

    private componentStore: DashboardComponentStore = {
        chart: {
            component: ExChartComponent,
            strategies: ["aggregateByCategory","aggregateByCategoryWithoutSeries", "singleSeriesChart",
            "aggregateCategoriesByProps","aggregateSeriesByProps","aggregateCategoriesByPropsWithoutSeries","rawDataToSeries"]

        },
        datatable: {
            component: ExDatatableComponent,
            // component: '<div gt-datatable2 options="ctrl.options"><div>',
            strategies: ["showSheetData", "groupByWithChange"]
        },
        // horizontalBusinessGroup: {
        //     component: HorizontalBusinessGroupComponent,
        //     // component: '<div gt-horizontal-bizz-group options="ctrl.options"></div>',
        //     strategies: ["groupBusinessBy"]
        // },
        kpi: {
            component: ExKPIComponent,
            // component: '<div gt-kpi-box options="ctrl.options"></div>',
            strategies: ["aggregateByColumn","aggregatePercentByColumn","filterDataAndAggregate","applyCustomForumlaOnColumns","applyCustomForumlaOnRows","countAllRows"]
        },

        horizontalBusinessTreeMap: {
            component: HorizontalBusinessGroupComponent,
            // component: '<div gt-horizontal-bizz-tree-map options="ctrl.options"></div>',
            strategies: ["horizontalBizzTreeMap"]
        },
        // regularTreeMap: {
        //     component: ExChartComponent,
        //     // component: '<div gt-regular-tree-map options="ctrl.options"></div>',
        //     strategies: ["buildRegularTreeMap"]
        // },
        combinationChart: {
            component: ExChartComponent,
            strategies: ["buildCombinationChart", "aggregateByCategory", "aggregateByCategoryWithoutSeries", "singleSeriesChart"]
        },
        projectReview: {
            component: ExProjectReviewComponent,
            // component: '<div gt-project-review options="ctrl.options"></div>',
            strategies: ["showSheetData"]
        },
        // materialSchDm: {
        //     component: ExChartComponent,
        //     // component: '<div ng-include="\'app/components/admin/adminDashboards/component-settings-templates/material-schdm/material-schdm-component-tpl.html\'"></div>',
        //     strategies: ["showSheetData"]
        // },
        // dynamicHtml: {
        //     component: ExChartComponent,
        //     // component: '<div gt-dynamic-html options="ctrl.options"></div>',
        //     strategies: ["showSheetData"]
        // }
    }

    constructor(private strategyService: StrategyService){}

    getDefinedComponentList() {
        return Object.keys(this.componentStore).filter((i) => i !== 'kpi');
    }

    getComponent(componentName: string): Type<any> | null {
        return this.componentStore[componentName] ? this.componentStore[componentName].component : null;
    }

    getComponentStrategies(componentName: string) {
        const allStrategies = this.strategyService.getAllStrategies();
        const strategyKeys = this.componentStore[componentName].strategies;
        return strategyKeys.map((key) => allStrategies[key]);
    }

    getAllComponents() {
        return this.componentStore
    }


}
